import React from 'react'
import CallMeBackInsteadBtn from 'src/Components/Common/CallMeBackInsteadBtn/CallMeBackInsteadBtn'
import WhatsappBtn from 'src/Components/Common/WhatsappBtn/WhatsappBtn'
import './AuthInfoReviewMobile.css'

const AuthInfoReviewMobile = (props) => {

  return (
    <div className='sticky-div-mobile'>
      <div className="auth-info-review-continue-button-wrapper-mobile">
        <button 
          className='auth-info-review-continue-button-mobile'
          disabled={!props.enableNext}
          onClick={() => props.nextClick()}
        >
          Continue
        </button>
      </div>
      <div className='auth-info-review-callmeback-wrapper-mobile'>
        <WhatsappBtn/>
        <CallMeBackInsteadBtn/>
      </div>
  </div>
  );
}

export default AuthInfoReviewMobile;